import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from '../locales/en/pages.json'
import fi from '../locales/fi/pages.json'
import sv from '../locales/sv/pages.json'
import fr from '../locales/fr/pages.json'
import de from '../locales/de/pages.json'

const resources = {
  en: { pages: en },
  fi: { pages: fi },
  sv: { pages: sv },
  fr: { pages: fr },
  de: { pages: de },
}

// Single source of truth for supported languages — derived from the bundled
// locale resources, so adding a new language to `resources` is sufficient.
export type SupportedLanguage = keyof typeof resources

export const SUPPORTED_LANGUAGES = Object.keys(resources) as SupportedLanguage[]

/**
 * Native display name (autonym) for a language code, e.g. 'fi' -> 'Suomi'.
 * Uses Intl.DisplayNames so new languages need no hardcoded name table.
 */
export function languageDisplayName(code: string): string {
  try {
    const name = new Intl.DisplayNames([code], { type: 'language' }).of(code)
    if (name) return name.charAt(0).toLocaleUpperCase(code) + name.slice(1)
  } catch {
    // Unknown code — fall through to returning the code itself
  }
  return code
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    ns: ['pages'],
    defaultNS: 'pages',

    supportedLngs: SUPPORTED_LANGUAGES,

    react: {
      useSuspense: false,
    },

    resources,
  })

export default i18n
